// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as PorterStoreOrderRepo from "./PorterStoreOrderRepo.bs.js";
import * as DummyPorterStoreOrderRepo from "./DummyPorterStoreOrderRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyPorterStoreOrderRepo.PorterStoreOrderRepo;
  } else {
    return PorterStoreOrderRepo.PorterStoreOrderRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
